import { createApp } from 'vue'
import App from './App.vue'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import VueParticles from 'vue-particles'
import { router } from './routes';
import { store } from './store/store'
// import Vuelidate from 'vuelidate'

import Maska from 'maska';

import 'dayjs/locale/pt-br'


const app = createApp(App);

app.use(router)
app.use(VueSweetalert2)
app.use(VueParticles)
app.use(store)
// app.use(Vuelidate)
app.use(Maska)

app.mount('#app');
